export default "__VITE_ASSET__$oUiuAXR7gZMKRQU56HW2w__ 40w, __VITE_ASSET__6kssa3xCT2YlMpIbbRNP$Q__ 80w";